<script>
import TournamentCard from "@/components/2025/Cards/TournamentCard.vue"

export default {
  name: 'TournamentGrid.vue',
  components: {TournamentCard},
  props: [],
  data() {
    return {
      tournaments: {
        freefire: {
          bg: require("@/assets/imgs/2025/cards-bg/freefire-card.png"),
          title: "FREE FIRE tournament",
          poolPrize: "200.000 Dhs",
          playMode: "4Vs4 BR",
          routeName: "free-fire"
        },
        eafc25: {
          bg: require("@/assets/imgs/2025/cards-bg/eafc-card.png"),
          title: "EA FC 25 tournament",
          poolPrize: "100.000 Dhs",
          playMode: "1Vs1",
          routeName: "eafc25"
        },
        valorant: {
          bg: require("@/assets/imgs/2025/cards-bg/valo-card.png"),
          title: "Valorant tournament",
          poolPrize: "100.000 Dhs",
          playMode: "5Vs5",
          routeName: "valorant"
        },
        streetFighter: {
          bg: require("@/assets/imgs/2025/cards-bg/streetfighter-card.png"),
          title: "Street Fighter 6 tournament",
          poolPrize: "100.000 Dhs",
          playMode: "1Vs1",
          routeName: "street-fighter"
        },
      }
    };
  },
  methods: {
    goToTournamnet(routeName){
      console.log("clicked: ", routeName)
      this.$router.push({name: routeName})
    },
  },
  mounted() {

  }
};
</script>

<template>
  <div class="row">
    <div class="col-12 col-md-6 p-2 px-sm-3 px-md-2" v-for="(tournament, key) in tournaments" :key="key">
      <TournamentCard :tournament="tournament" @click.native="goToTournamnet(tournament.routeName)"/>
    </div>
  </div>
</template>

<style scoped>
</style>
